import React from "react";
import styled from "styled-components";

// Styled-component for Section
const SectionWrapper = styled.section`
  width: 80%;
  margin: 0 auto; /* Centers the section within the MainContainer */
  padding: 2rem 0;
`;

const Section = ({ children }) => {
  return <SectionWrapper>{children}</SectionWrapper>;
};

export default Section;
